/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IncentiveReport,
    IncentiveReportFromJSON,
    IncentiveReportFromJSONTyped,
    IncentiveReportToJSON,
} from './IncentiveReport';
import {
    QueryInfo,
    QueryInfoFromJSON,
    QueryInfoFromJSONTyped,
    QueryInfoToJSON,
} from './QueryInfo';

/**
 * 
 * @export
 * @interface IncentiveReportsResponse
 */
export interface IncentiveReportsResponse {
    /**
     * 
     * @type {Array<IncentiveReport>}
     * @memberof IncentiveReportsResponse
     */
    results: Array<IncentiveReport>;
    /**
     * 
     * @type {QueryInfo}
     * @memberof IncentiveReportsResponse
     */
    listResult: QueryInfo;
    /**
     * Pagination token used in retrieving another page of items
     * @type {string}
     * @memberof IncentiveReportsResponse
     */
    paginationToken?: string;
    /**
     * Whether there are more items in the next page
     * @type {boolean}
     * @memberof IncentiveReportsResponse
     */
    hasNextPage?: boolean;
    /**
     * Whether there are more items in the previous page
     * @type {boolean}
     * @memberof IncentiveReportsResponse
     */
    hasPreviousPage?: boolean;
}

export function IncentiveReportsResponseFromJSON(json: any): IncentiveReportsResponse {
    return IncentiveReportsResponseFromJSONTyped(json, false);
}

export function IncentiveReportsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncentiveReportsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(IncentiveReportFromJSON)),
        'listResult': QueryInfoFromJSON(json['listResult']),
        'paginationToken': !exists(json, 'paginationToken') ? undefined : json['paginationToken'],
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'hasPreviousPage': !exists(json, 'hasPreviousPage') ? undefined : json['hasPreviousPage'],
    };
}

export function IncentiveReportsResponseToJSON(value?: IncentiveReportsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(IncentiveReportToJSON)),
        'listResult': QueryInfoToJSON(value.listResult),
        'paginationToken': value.paginationToken,
        'hasNextPage': value.hasNextPage,
        'hasPreviousPage': value.hasPreviousPage,
    };
}

